import { render, staticRenderFns } from "./BulkActions.vue?vue&type=template&id=27936c92"
import script from "./BulkActions.vue?vue&type=script&lang=js"
export * from "./BulkActions.vue?vue&type=script&lang=js"
import style0 from "./BulkActions.vue?vue&type=style&index=0&id=27936c92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports